<template>
  <s-sign-call-back-view />
</template>
<script>
import SSignCallBackView from '@/components/SSignCallBackView'
import { getStorage } from '../utils/storageUtil'
// import { BUSINESS_CODE } from '../constant/constant'
import { globalModule } from '../store/moduleName'
import workflowApi from '../api/workflow/workflow'
import { SIGNING_JOB_STATUS } from '@/constant/constant'
// import esignApi from '../api/esign/signing'

export default {
  components: {
    SSignCallBackView
  },
  data: () => {
    return {}
  },
  async mounted () {
    if (!this.$route.query['error']) {
      let eSignOAuthCode = this.$route.query['code']
      let cb = resp => {
        if (resp.status === 201 || resp.status === 200) {
          if (resp.data.status === SIGNING_JOB_STATUS.COMPLETE) {
            this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(getStorage('g2e-successMessageKey')))
          } else {
            this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(getStorage('g2e-failMessageKey')))
          }
        } else if (cb.status === 400) {
          // replace by global error message handler
        } else {
          this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(getStorage('g2e-failMessageKey')))
        }
        this.$router.push(getStorage('g2e-redirectPath'))
      }
      let signBatchId = ''
      await workflowApi.signAndComplete(resp => {
        signBatchId = resp.data
      }, eSignOAuthCode) // Dont' wait for call back
      // esignApi.waitForSigningCartEmpty(cb)
      workflowApi.waitForSigningJobComplete(cb, signBatchId)
    } else {
      this.$store.dispatch(globalModule + '/setErrorMessage', this.$t(getStorage('g2e-failMessageKey')))
      this.$router.push(getStorage('g2e-redirectPath'))
    }
  }
}
</script>
